module.exports = __webpack_public_path__ + "static/img/services5.1a34724.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/services5.png
// module id = Z+kP
// module chunks = 0